<template>
  <div class="row">
    <div class="col-12">
      <form action="/?#/">
        <div
          v-if="bookingResult.error"
          class="alert alert-danger mt-5"
          role="alert"
        >
          <h3 class="mb-3">
            Something went wrong!
          </h3>
          <p>{{bookingResult.error.status}}: {{ bookingResult.error.data.message ? bookingResult.error.data.message : bookingResult.error.data }}</p>
        </div>
        <div
          v-if="!bookingResult.error && bookingResult.bookingConfirmResponse"
          class="alert alert-success mt-5"
          role="alert"
        >
          <h3 class="mb-3">
            Payment has been successful
          </h3>
          <h5 class="mb-3">
            Booking reference: {{ bookingResult.bookingConfirmResponse.data.booking.reference }}
          </h5>
          <p>We will send you an email confirmation shortly to: {{ bookingResult.booking.customer.email }}</p>
          <p>Payment of {{ $n(bookingResult.bookingConfirmResponse.data.booking.price, 'currency', languageCode) }} has been processed against your card.</p>
          <router-link
            :to="{ name: 'bookingDetail', params: { bookingId: bookingResult.bookingConfirmResponse.data.booking.id } }"
            class="btn btn-primary mt-2"
            tag="button"
          >
            Review booking
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
    name: 'BookingResult',
    props: ['bookingResult'],
    computed: {
        languageCode () {
            var code = this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
            if (code !== null) {
                return code
            }
            return 'en-GB'
        }
    }
}
</script>
